import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getNotifyRolesForPerson, GetNotifyRolesResponse } from "../../../queries/notify";

export function useNotifyRolesForPerson({
  personId,
  onSuccess,
}: {
  personId?: number | null;
  onSuccess?: (data: GetNotifyRolesResponse) => void;
} = {}) {
  const networkHeaders = useNetworkHeaders();

  const { data: notifyRoles, isLoading: isNotifyRolesLoading } = useQuery(
    buildNotifyRolesForPersonQueryKey({ personId }),
    getNotifyRolesForPerson(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      enabled: !!personId,
      onSuccess,
    },
  );

  return {
    notifyRoles,
    isNotifyRolesLoading,
  };
}

export function buildNotifyRolesForPersonQueryKey(params: { personId?: number | null }) {
  return ["notifyRolesForPerson", params];
}
